const pictureTeaserCardStyle = {
  card: {
    position: "relative",
    overflow: "hidden",
    maxWidth: "340px",
  },
  image: {
    width: "100%",
    aspectRatio: "1 / 1",
    display: "block",
    objectFit: "cover",
    objectPosition: "center",
  },
  textContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    padding: "1rem",
    height: "8rem",
    justifyContent: "flex-end",
  },
};

export default pictureTeaserCardStyle;
